import { render, staticRenderFns } from "./note_stats.vue?vue&type=template&id=584ec0f8"
import script from "./note_stats.vue?vue&type=script&lang=js"
export * from "./note_stats.vue?vue&type=script&lang=js"
import style0 from "./note_stats.vue?vue&type=style&index=0&id=584ec0f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports